import {
    Drawer,
} from '@material-ui/core';
import BidProfileSummary from '../../../BidProfileSummary';
import BidProfileSummaryMobile from '../../../BidProfileSummary/BidProfileSummaryMobile';
import './AssignedShiftlinePanel.scss';

/**
 * @param {{
*  open: boolean,
*  onClose: () => void,
*  isMobile?: boolean,
* }} props
*/
function AssignedShiftlinePanel({ open, onClose = () => {}, isMobile = false }) {
    return (
        <Drawer
            open={open}
            anchor="right"
            className="obss-drawer"
        >
            <div className="obss-drawer-content">
                {
                    isMobile
                        ? <BidProfileSummaryMobile onBack={onClose} />
                        : <BidProfileSummary onBack={onClose} />
                }
            </div>
        </Drawer>
    );
}

export default AssignedShiftlinePanel;
